import '../filter_view.js.coffee'

Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedFilterView extends Common.Dashboard.Filters.FilterView
  template: JST['backbone/templates/common/dashboard/filters/applied/applied_filter']
  className: 'applied-filter'

  events:
    'click .applied-filter-remove': 'removeFilter'

  initialize: ({filter, isReadOnly = false}) ->
    super({filter})
    @valueViews = []
    @isReadOnly = isReadOnly

  render: =>
    @_renderTemplate()
    @_renderValues()
    @$el.addClass('readOnly') if @isReadOnly
    @

  _renderTemplate: ->
    @$el.empty().append @template({
      title: @_displayTitle()
      removable: @filter.isRemovable()
    })

  _renderValues: =>
    view.remove() for view in @valueViews
    @valueViews = (@_renderValue(value) for value in @_displayValues())

  _renderValue: (value) =>
    view = new Common.Dashboard.Filters.AppliedFilterValueView
      value: value
      isReadOnly: @isReadOnly
    @$('.applied-filter-values-container').append view.render().el
    view

  _displayTitle: =>
    @filter.translatedFilterType()

  _displayValues: =>
    @filter.getValues()

  removeFilter: ->
    @trigger('filter:remove', (compositeFilter) =>
      @filter.removeFromCompositeFilter(compositeFilter))
